import type { JobStatus, SearchControlAction } from '@splunk/dashboard-types';
import { RUNNING_SEARCH_STATUSES } from '@splunk/dashboard-utils';

export const shouldFinalize = ({
    status,
    action,
}: {
    status: JobStatus | undefined;
    action: SearchControlAction;
}) =>
    action === 'finalize' &&
    status !== undefined &&
    status !== 'finalizing' &&
    RUNNING_SEARCH_STATUSES.includes(status);
